import React, { useEffect, useState } from "react";
import { Select } from "antd";
import style from "./index.module.scss";
import OptionsView from "./Components/OptionsView";
import { SelectProps } from "antd/es/select";
import useClickOutside from "utils/useClickOutside";

export interface Option {
    key: string;
    value: string;
    label: string;
}

interface UserPicker extends Omit<SelectProps<any>, "onChange"> {
    initVal: string[];
    optionsData: Option[]; //树形结构数据
    onChange: (users: string[]) => void; //获取选中结构
}

export default function SelectPicker({
    initVal,
    optionsData,
    onChange,
    ...restProps
}: UserPicker) {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<string[]>(initVal || []);

    const ref = useClickOutside<HTMLDivElement>(() => setOpen(false));

    useEffect(() => {
        onChange(selected);
    }, [selected]);

    // 相应输入框变更，主要作用于清除和单个删除
    function changeHandler(value: string[]) {
        setSelected(value);
        setOpen(false);
    }

    function dropdownRender() {
        if (!open) return <div />;

        return (
            <OptionsView
                selected={selected}
                optionsData={optionsData}
                handleSelected={setSelected}
                setOpen={() => setOpen(false)}
            />
        );
    }

    return (
        <div className={style.root}>
            <div ref={ref}>
                <Select
                    showArrow
                    mode="multiple"
                    value={selected}
                    dropdownRender={dropdownRender}
                    getPopupContainer={() => ref.current!}
                    open={open}
                    onChange={changeHandler}
                    onDropdownVisibleChange={() => setOpen(true)}
                    {...restProps}>
                    {optionsData.map(item => (
                        <Select.Option
                            value={item.value}
                            key={item.value}
                            title={item.label}>
                            {item.label}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        </div>
    );
}
